<template>
    <div class="page">
        <box>
            <el-form label-position="right" label-width="90px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="通道编号" class="EL-Form-Item">
                        <el-select v-model="mainSearch.whCode" filterable placeholder="请选择" clearable="clearable">
                            <el-option v-for="item in warehouseList" :key="item.whId" :value="item.whCode" :label="item.whCode+'-'+item.whName">{{item.whCode}}-{{item.whName}}</el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="订单编号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.orderCode" placeholder="请输入" @change="saveSearch()" clearable="clearable"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.matCode" placeholder="请输入" @change="saveSearch()"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="包装箱号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.boxBarcode" @change="saveSearch()" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getMoveLocation">查询</el-button>
                        <el-button class="btn-t-delete" @click="resetCheck">重置</el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.date[0]" @change="saveSearch()" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions01"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.date[1]" @change="saveSearch()" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions1"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-form>
        </box>
        <box fill>
            <plabel text="库品质检">
                <el-button v-authority="'BACK_MENU2_M5_B1'" @click="openInventoryQualityInspectionDialog()" class="btn-t-edit">质检记录</el-button>
                <el-button v-authority="'BACK_MENU2_M5_B2'" @click="openQualifiedLcCodeDialog()" class="btn-t-edit">合格</el-button>
                <el-button v-authority="'BACK_MENU2_M5_B3'" @click="openUnqualifiedLcCodeDialog()" class="btn-t-edit">不合格</el-button>
                <el-button v-authority="'BACK_MENU2_M5_B4'" @click="openUnqualifiedSelectionDialog()" class="btn-t-edit">挑选</el-button>
                <el-button v-authority="'BACK_MENU2_M5_B5'" @click="openTransferLibrary" class="btn-t-edit">移库</el-button>
                <el-button v-authority="'BACK_MENU2_M5_B6'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <h-table :headerCellStyle="mainData.headerCellStyle" style="flex: 1" @pageChange="getMoveLocation" :data="mainData.data" pagination :nowPage.sync="mainData.nowPage" :pageSize.sync="mainData.pageSize" :total.sync="mainData.total" ref="hTable" @selectionChange="selectAllPrintLists">
                <el-table-column type="selection" align="center"></el-table-column>
                <el-table-column label="通道编号" align="center" prop="whCode"></el-table-column>
                <el-table-column label="物料编号" align="center" prop="matCode"></el-table-column>
                <el-table-column label="物料描述" align="center" prop="matName"></el-table-column>
                <el-table-column label="物料数量" align="center" prop="matQuan"></el-table-column>
                <!-- <el-table-column label="已分配数量" align="center" prop="matDistrQuan"></el-table-column>
                <el-table-column label="可用数量" align="center" prop="matAvaliableQuan">
                    <template slot-scope="scope">
                        {{scope.row.matQuan - scope.row.matDistrQuan}}
                    </template>
                </el-table-column> -->
                <el-table-column label="物料批次" align="center" prop="batchNo"></el-table-column>
                <el-table-column label="库位" align="center" prop="lcCode"></el-table-column>
                <el-table-column label="包装箱号" align="center" prop="boxBarcode"></el-table-column>
                <el-table-column label="订单编号" align="center" prop="orderCode"></el-table-column>
                <el-table-column label="规值" prop="matSpecs" align="center">
                </el-table-column>
                <el-table-column label="物料状态" align="center" width="120px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.wiStatus == 'NORMAL'">正常</span>
                        <span v-if="scope.row.wiStatus == 'FREEZE'">拣配中</span>
                        <span v-if="scope.row.wiStatus == 'AGFREEZE'">冻结</span>
                    </template>
                </el-table-column>
                <el-table-column label="入库时间" align="center" prop="matCreateTime"></el-table-column>
                <el-table-column label="备注" align="center" prop="remark"></el-table-column>
            </h-table>
        </box>

        <el-dialog title="移库" :visible.sync="transferLibraryDialog" class="minInfoDialog" :close-on-click-modal="false" :show-close="false">
            <div style="overflow: hidden; padding-bottom: 10px">
                <el-form label-position="right" label-width="80px">
                    <el-form-item label="移库库位" prop="lcCode" class="EL-Form-Item">
                        <el-select v-model="qualifiedLcCode" clearable="clearable" placeholder="请选择" filterable remote :remote-method="remoteMethodQualifiedLcCode">
                            <el-option v-for="(item, index) in lcCodeQCList" :key="index" :value="item.lcCode" :label="item.lcCode"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeTransferLibrary()" type="info" class="btn-t-info">关 闭</el-button>
                <el-button @click="transferInventoryQuality()" :loading="transferInventoryQualityLoading" class="btn-t-edit">确 认</el-button>
            </div>
        </el-dialog>

        <el-dialog title="合格" :visible.sync="qualifiedLcCodeDialog" class="minInfoDialog" :close-on-click-modal="false" :show-close="false">
            <div style="overflow: hidden; padding-bottom: 10px">
                <el-form label-position="right" label-width="80px">
                    <el-form-item label="合格库位" prop="lcCode" class="EL-Form-Item">
                        <el-select v-model="qualifiedLcCode" clearable="clearable" placeholder="请选择" filterable remote :remote-method="remoteMethodQualifiedLcCode">
                            <el-option v-for="(item, index) in lcCodeQCList" :key="index" :value="item.lcCode" :label="item.lcCode"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeQualifiedLcCodeDialog()" type="info" class="btn-t-info">关 闭</el-button>
                <el-button @click="frozenMaterialQualified('10')" :loading="transferInventoryQualityLoading" class="btn-t-edit">确 认</el-button>
            </div>
        </el-dialog>

        <el-dialog title="不合格" :visible.sync="unqualifiedLcCodeDialog" class="minInfoDialog" :close-on-click-modal="false" :show-close="false">
            <div style="overflow: hidden; padding-bottom: 10px">
                <el-form label-position="right" label-width="80px">
                    <el-form-item label="不合格库位" prop="lcCode" class="EL-Form-Item">
                        <el-select v-model="qualifiedLcCode" clearable="clearable" placeholder="请选择" filterable remote :remote-method="remoteMethodQualifiedLcCode">
                            <el-option v-for="(item, index) in lcCodeQCList" :key="index" :value="item.lcCode" :label="item.lcCode"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeUnqualifiedLcCodeDialog()" type="info" class="btn-t-info">关 闭</el-button>
                <el-button @click="frozenMaterialQualified('20')" :loading="transferInventoryQualityLoading" class="btn-t-edit">确 认</el-button>
            </div>
        </el-dialog>

        <el-dialog title="挑选不合格品" :visible.sync="unqualifiedSelectionDialog" class="minInfoDialog" :close-on-click-modal="false" :show-close="false">
            <div style="overflow: hidden; padding-bottom: 10px">
                <el-form label-position="right" label-width="80px">
                    <el-form-item label="不合格数量" prop="lcCode" class="EL-Form-Item">
                        <el-input v-model="unqualifiedNumber" placeholder="请输入" clearable="clearable" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                    </el-form-item>
                    <el-form-item label="不合格库位" prop="lcCode" class="EL-Form-Item">
                        <el-select v-model="unqualifiedLcCode" clearable="clearable" placeholder="请选择" filterable remote :remote-method="remoteMethodUnQualifiedLcCode">
                            <el-option v-for="(item, index) in unqualifiedLcCodeList" :key="index" :value="item.lcCode" :label="item.lcCode"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeUnqualifiedSelectionDialog()" type="info" class="btn-t-info">关 闭</el-button>
                <el-button @click="frozenMaterialUnQualifiedSelection()" :loading="unqualifiedSelectionLoading" class="btn-t-edit">确 认</el-button>
            </div>
        </el-dialog>

        <!-- 库品质检记录 -->
        <el-dialog title="库品质检记录" :visible.sync="inventoryQualityInspectionDialog" class="infoDialog" :close-on-click-modal="false" :show-close="false">
            <el-form label-position="right" label-width="90px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="通道编号" class="EL-Form-Item">
                        <el-select v-model="qualityInspectionSearch.whCode" filterable placeholder="请选择" clearable="clearable">
                            <el-option v-for="item in warehouseList" :key="item.whId" :value="item.whCode" :label="item.whCode+'-'+item.whName">{{item.whCode}}-{{item.whName}}</el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="订单编号" class="EL-Form-Item">
                        <el-input v-model="qualityInspectionSearch.orderCode" placeholder="请输入" clearable="clearable"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="qualityInspectionSearch.matCode" clearable placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5" v-if="mainSearch.fcCode">
                    <el-form-item label="物料批次" class="EL-Form-Item">
                        <el-input v-model="qualityInspectionSearch.batchNo" clearable placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getInventoryQualityInspectionList">查询</el-button>
                        <el-button class="btn-t-delete" @click="resetQualityInspectionSearch">重置</el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5" v-if="!mainSearch.fcCode">
                    <el-form-item label="物料批次" class="EL-Form-Item">
                        <el-input v-model="qualityInspectionSearch.batchNo" clearable placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料状态" class="EL-Form-Item" placeholder="请选择">
                        <el-select v-model="qualityInspectionSearch.qualityStatus" clearable="clearable">
                            <el-option key="0" value="" label="全部"></el-option>
                            <el-option label="合格" value="10"></el-option>
                            <el-option label="不合格" value="20"></el-option>
                            <el-option label="移库" value="30"></el-option>
                            <el-option label="挑选" value="40"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="箱号" class="EL-Form-Item">
                        <el-input v-model="qualityInspectionSearch.boxBarcode" placeholder="请输入" clearable="clearable"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="qualityInspectionSearch.date[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="qualityInspectionSearch.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-form>
            <h-table :headerCellStyle="qualityInspectionList.headerCellStyle" style="flex: 1" @pageChange="getInventoryQualityInspectionList" :data="qualityInspectionList.data" pagination :nowPage.sync="qualityInspectionList.nowPage" :pageSize.sync="qualityInspectionList.pageSize" :total.sync="qualityInspectionList.total" ref="hTable" @selectionChange="selectAllPrintLists">
                <!-- <el-table-column type="selection" align="center"></el-table-column> -->
                <el-table-column label="通道编号" align="center" prop="whCode"></el-table-column>
                <el-table-column label="订单编号" align="center" prop="orderCode"></el-table-column>
                <el-table-column label="物料编号" align="center" prop="matCode"></el-table-column>
                <el-table-column label="物料描述" align="center" prop="matName"></el-table-column>
                <el-table-column label="合格数量" align="center" prop="matQuan"></el-table-column>
                <el-table-column label="合格库位" align="center" prop="lcCode"></el-table-column>
                <el-table-column label="物料批次" align="center" prop="batchNo"></el-table-column>
                <el-table-column label="包装箱号" align="center" prop="boxBarcode"></el-table-column>
                <el-table-column label="规值" align="center" prop="matSpecs"></el-table-column>
                <el-table-column label="不合格库位" align="center" prop="unQualityLcCode"></el-table-column>
                <el-table-column label="不合格数量" align="center" prop="unQualityNumber"></el-table-column>
                <el-table-column label="质检状态" align="center" width="120px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.qualityStatus == '10'">合格</span>
                        <span v-if="scope.row.qualityStatus == '20'">不合格</span>
                        <span v-if="scope.row.qualityStatus == '30'">移库</span>
                        <span v-if="scope.row.qualityStatus == '40'">挑选</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作人" align="center" prop="person"></el-table-column>
                <el-table-column label="操作人工号" align="center" prop="personNumber"></el-table-column>
                <el-table-column label="入库时间" align="center" prop="matCreateTime"></el-table-column>
                <el-table-column label="创建时间" align="center" prop="createTime"></el-table-column>
            </h-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeInventoryQualityInspectionDialog" type="info">关 闭</el-button>
                <!-- <el-button @click="quality()" type="danger">确 认</el-button> -->
            </div>
        </el-dialog>
        <!-- 详情 -->
        <el-dialog title="详情" :visible.sync="dialogShow" class="infoDialog" :close-on-click-modal="false" :show-close="false">
            <h-table :headerCellStyle="mainData.headerCellStyle" style="flex: 1" :data="checkDetailData.data" pagination :nowPage.sync="checkDetailData.nowPage" :pageSize.sync="checkDetailData.pageSize" :total.sync="checkDetailData.total" ref="hTable" @selectionChange="selectcheckDetail">
                <el-table-column type="selection" align="center" :selectable="checkDetailselectable"></el-table-column>
                <el-table-column label="物料编号" align="center" prop="matCode"></el-table-column>
                <el-table-column label="物料描述" align="center" prop="matName"></el-table-column>
                <el-table-column label="数量" align="center" prop="matName"></el-table-column>
                <el-table-column label="箱号" align="center" prop="boxBarcode"></el-table-column>
                <el-table-column label="批次" align="center" prop="batchNo"></el-table-column>
                <el-table-column label="状态" align="center" width="120px" prop="scStatus">
                    <template slot-scope="scope">
                        <span v-if="scope.row.clickBoolean">
                            <el-select v-model="scope.row.scdStatus" placeholder="请选择" filterable>
                                <el-option label="合格" value="10">合格</el-option>
                                <el-option label="不合格" value="20">不合格</el-option>
                            </el-select>
                        </span>
                        <span v-else>
                            <span v-if="scope.row.scdStatus == null ">
                                <span v-if="scope.row.scdStatus == '10'">合格</span>
                                <span v-if="scope.row.scdStatus == '20'">不合格</span>
                                <span @click="tabClick(scope.row)" v-authority="'BACK_MENU_UPDATE'"><i class="el-icon-edit"></i></span>
                            </span>
                            <span v-else>
                                <span v-if="scope.row.scdStatus == '10'">合格</span>
                                <span v-if="scope.row.scdStatus == '20'">不合格</span>
                            </span>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="操作人" align="center" prop="person"></el-table-column>
                <el-table-column label="更新时间" align="center" prop="updateTime"></el-table-column>
                <el-table-column label="创建时间" align="center" prop="createTime"></el-table-column>
            </h-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="checkDetailClose()" type="info">取 消</el-button>
                <el-button @click="affirmCheckDetail()" type="danger">确 认</el-button>
            </div>
        </el-dialog>

        <!-- 打印 -->
        <el-dialog title="打印" :visible.sync="printShow" width="1000px" :close-on-click-modal="false" style="height:100%">
            <div class="divdiv">
                <v-print :doPrint.sync="print">
                    <div id="demo" class="demo11">
                        <div style="margin-top:20px;margin-left:800px">
                            <el-button class="btn-t-info" type="info" @click="(printShow = false), (printList = [])">取消</el-button>
                            <el-button class="btn-t-edit" @click="print=true,printShow=false">打印</el-button>
                        </div>
                        <div class="div1">打印时间：{{printTime}}</div>
                        <div class="div">
                            <table border="1" cellpadding="0" cellspacing="0">
                                <thead style="display:table-header-group;font-weight:bold">
                                    <tr>
                                        <th>通道编号</th>
                                        <th>物料编号</th>
                                        <th>物料描述</th>
                                        <th>物料数量</th>
                                        <th>物料批次</th>
                                        <th>库位</th>
                                        <th>包装箱号</th>
                                        <th>规值</th>
                                        <th>物料状态</th>
                                        <th>入库时间</th>
                                        <th>备注</th>
                                    </tr>
                                </thead>
                                <tr v-for="(item, index) in printData" :key="index">
                                    <td>{{item.whCode}}</td>
                                    <td>{{item.matCode}}</td>
                                    <td>{{item.matName}}</td>
                                    <td>{{item.matQuan}}</td>
                                    <td>{{item.batchNo}}</td>
                                    <td>{{item.lcCode}}</td>
                                    <td>{{item.boxBarcode}}</td>
                                    <td>{{item.matSpecs}}</td>
                                    <td>
                                        <span v-if="item.wiStatus == 'NORMAL'">正常</span>
                                        <span v-if="item.wiStatus == 'FREEZE'">拣配中</span>
                                        <span v-if="item.wiStatus == 'OVERTIME'">过期</span>
                                        <span v-if="item.wiStatus == 'DELETE'">作废</span>
                                        <span v-if="item.wiStatus == 'AGFREEZE'">人工冻结</span>
                                    </td>
                                    <td>{{item.matCreateTime}}</td>
                                    <td>{{item.remark}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </v-print>
            </div>
            <div style="margin-top: 50px;height:70px">
                <!-- <el-button class="btn-t-edit" @click="(printShow = false), (printList = [])">取消</el-button>
                <el-button class="btn-t-edit" @click="print=true,printShow=false">打印</el-button> -->
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import vPrint from 'syl-vue-printer'
    import moment from "moment";
    export default {
        name: "StockCheck",
        components: {
            vPrint
        },
        data() {
            return {
                scdStatus: [],
                selectcheckDetailList: [],
                printData: [], //打印数据
                print: false,
                printShow: false,
                printObj: {
                    id: "demo",
                    popTitle: "",
                },
                printTime: moment(new Date).format("yyyy-MM-DD"),

                warehouseList: [],
                mainData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                checkData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                checkDetailData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                checkSearch: {
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    scCode: "",
                    matCode: "",
                    scStatus: "",
                    fcCode: localStorage.getItem("fcCode") || "",
                    person: "",
                    orderCode: "",
                    date: [],
                },
                // 筛选条件
                mainSearch: {
                    fcCode: localStorage.getItem("fcCode") || "", //	工厂编号
                    whCode: "", //	通道编号
                    lcCode: "", //	库位编号
                    lcType: "",
                    matCode: "", //	物料编号
                    matName: "", //	物料描述
                    batchNo: "", //	批次号
                    wiStatus: "AGFREEZE", //	库存状态 normal
                    boxBarcode: "", //	箱号
                    orderCode: "", //  订单编号
                    matSpecs: "", //  规值
                    lcCodeList: "DM0001,DM0002,C002", //  冻结地面货位
                    date: [],
                },
                //全选
                checkList: [],
                dialogShow: false,

                downloadLoading: false, //下载中
                //库区
                dictDataList: [],
                //选中的库区
                chooseDictDataList: [],

                selectAllPrintList: [],

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,

                //移库窗口
                transferLibraryDialog: false,
                //所有通道的QC货位
                lcCodeQCList:[],
                //选中的QC货位
                lcCodeQC:"",
                //移库按钮加载
                transferInventoryQualityLoading:false,
                //合格窗口
                qualifiedLcCodeDialog: false,
                //合格库位
                qualifiedLcCode: "",
                //不合格窗口
                unqualifiedLcCodeDialog: false,
                //不合格库位
                unqualifiedLcCode: "",
                //不合格数量
                unqualifiedNumber: "",
                //挑选不合格品窗口
                unqualifiedSelectionDialog: false,
                //挑选按钮动态加载
                unqualifiedSelectionLoading: false,
                //不合格品货位集合
                unqualifiedLcCodeList:[],
                //远程搜索loading
                lcCodeLoading: false,
                //质检记录筛选条件
                qualityInspectionSearch: {
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    fcCode: localStorage.getItem("fcCode") || "", //	工厂编号
                    whCode: "", //	通道编号
                    lcCode: "", //	库位编号
                    lcType: "",
                    matCode: "", //	物料编号
                    matName: "", //	物料描述
                    batchNo: "", //	批次号
                    wiStatus: "AGFREEZE", //	库存状态 normal
                    boxBarcode: "", //	箱号
                    orderCode: "", //  订单编号
                    matSpecs: "", //  规值
                    qualityStatus: "",  //质检状态
                    date: [],
                },
                //质检记录集合
                qualityInspectionList:{
                    data: [],
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                //质检记录窗口
                inventoryQualityInspectionDialog: false,
                //移库库位集合
                moveLocationList:[],
                //移库库位号
                moveLocations: "",

            };
        },
        watch: {
            chooseDictDataList: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getMoveLocation(newVal);
                    }, 1000)
                },
                deep: true,
            },
            qualityInspectionSearch: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getInventoryQualityInspectionList(newVal);
                    }, 1000)
                },
                deep: true,
            },
            mainSearch:{
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getMoveLocation(newVal);
                    }, 1000)
                },
                deep: true,    
            }
        },
        computed: {
            pickerOptions() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.mainSearch.date[0]) {
                            return time.getTime() < new Date(_this.mainSearch.date[0]);
                        }
                    }
                }
            },
            pickerOptions0() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.mainSearch.date[1]) {
                            return time.getTime() > new Date(_this.mainSearch.date[1]);
                        }
                    }
                }
            },
            pickerOptions1() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.checkSearch.date[0]) {
                            return time.getTime() < new Date(_this.checkSearch.date[0]);
                        }
                    }
                }
            },
            pickerOptions01() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.checkSearch.date[1]) {
                            return time.getTime() > new Date(_this.checkSearch.date[1]);
                        }
                    }
                }
            },
        },
        methods: {
            tabClick(row) {
                this.$set(row, "clickBoolean", true);
            },
            /**
             * 物料冻结挑选
             */
            frozenMaterialUnQualifiedSelection(){
                if (this.selectAllPrintList.length == 0) {
                    this.$message({
                        message: "请至少选择一条冻结库存记录！",
                        type: "warning",
                    });
                    return
                } else if(this.unqualifiedNumber == ""){
                    this.$message({
                        message: "请输入不合格品数量！",
                        type: "warning",
                    });
                    return
                } else if(this.unqualifiedLcCode == ""){
                    this.$message({
                        message: "请选择不合格品库位！",
                        type: "warning",
                    });
                    return
                } else{
                    this.$confirm("是否确认挑选的不合格品数量和库位吗?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.unqualifiedSelectionLoading = true;
                        this.$http
                            .request({
                                url: "/api/order/frozenMaterialUnQualifiedSelection",
                                method: "POST",
                                params: {
                                    fcCode: localStorage.getItem("fcCode") || "",
                                    qualityStatus: "40",
                                    unQualityNumber: this.unqualifiedNumber,
                                    unQualityLcCode: this.unqualifiedLcCode,
                                    person: localStorage.getItem("user"),
                                    personNumber: localStorage.getItem("empNumber"),
                                },
                                data: this.selectAllPrintList[0]
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "库存质检挑选成功！",
                                        type: "success",
                                    });
                                    this.getMoveLocation();
                                    this.closeUnqualifiedSelectionDialog();
                                }else{
                                    this.$message({
                                        message: resp.message,
                                        type: "warning",
                                    });
                                }
                                this.unqualifiedSelectionLoading = false;
                            })
                            .catch((error) => {
                                this.unqualifiedSelectionLoading = false;
                                this.$message({
                                    message: "操作失败",
                                    type: "warning",
                                });
                            });                     
                    })
                    .catch(() => {
                        this.unqualifiedSelectionLoading = false;
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
                }
                
            },

            /**
             * 打开挑选不合格品窗口
             */
            openUnqualifiedSelectionDialog(){
                this.getSysLocationUnQualified();
                this.unqualifiedSelectionDialog = true;
            },

            /**
             * 关闭挑选不合格品窗口
             */
            closeUnqualifiedSelectionDialog(){
                this.unqualifiedLcCode = "";
                this.unqualifiedLcCodeList = [];
                this.unqualifiedSelectionDialog = false;
            },

            /**
             * 打开质检记录窗口
             */
            openInventoryQualityInspectionDialog(){
                this.getInventoryQualityInspectionList();
                this.inventoryQualityInspectionDialog = true;    
            },

            /**
             * 关闭质检记录窗口
             */
            closeInventoryQualityInspectionDialog(){
                this.inventoryQualityInspectionDialog = false;
            },

            /**
             * 获取所有的质检记录
             */
            getInventoryQualityInspectionList() {
                this.$http
                    .request({
                        url: "/api/order/getInventoryQualityInspectionList",
                        method: "GET",
                        params: {
                            pageNum: this.qualityInspectionList.nowPage, // 页号
                            pageSize: this.qualityInspectionList.pageSize, // 页大小
                            fcCode: localStorage.getItem("fcCode") || "",
                            whCode: this.qualityInspectionSearch.whCode, // 通道编号
                            orderCode: this.qualityInspectionSearch.orderCode, // 订单编号
                            matCode: this.qualityInspectionSearch.matCode, // 物料编号
                            batchNo: this.qualityInspectionSearch.batchNo, // 批次号
                            qualityStatus: this.qualityInspectionSearch.qualityStatus, // 物料状态
                            boxBarcode: this.qualityInspectionSearch.boxBarcode, // 箱号
                            beginTime: this.qualityInspectionSearch.date ? this.qualityInspectionSearch.date[0] : null,
                            endTime: this.qualityInspectionSearch.date ? this.qualityInspectionSearch.date[1] : null,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.qualityInspectionList.data = resp.data.list;
                            this.qualityInspectionList.total = resp.data.total;
                        }else{
                            this.$message({
                                message: resp.message,
                                type: "warning",
                            });
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },

            /**
             * 远程搜索不合格品库位号
             */
            remoteMethodUnQualifiedLcCode(query) {
                if (query !== '') {
                    this.lcCodeLoading = true;

                    this.unqualifiedLcCode = query;
                    this.getSysLocationUnQualified(query);

                    setTimeout(() => {
                        this.lcCodeLoading = false;
                        if (this.unqualifiedLcCodeList != undefined) {
                            this.unqualifiedLcCodeList = this.unqualifiedLcCodeList.filter(item => {
                                return item.lcCode.toLowerCase()
                                    .indexOf(query.toLowerCase()) > -1;
                            });
                        }
                    }, 200);
                } else {
                    this.unqualifiedLcCodeList = [];
                }
            },
            /**
             * 根据用户工厂编号获取所有的库位
             */
            getSysLocationUnQualified(LcCode) {
                this.$http
                    .request({
                        url: "/api/location/getLaCodeAllByType",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            lcCode: LcCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.unqualifiedLcCodeList = resp.data.list;
                        }else{
                            this.$message({
                                message: resp.message,
                                type: "warning",
                            });
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },

            /**
             * 远程搜索库位号
             */
            remoteMethodQualifiedLcCode(query) {
                if (query !== '') {
                    this.lcCodeLoading = true;

                    this.qualifiedLcCode = query;
                    this.getSysLocationQualified(query);

                    setTimeout(() => {
                        this.lcCodeLoading = false;
                        if (this.lcCodeQCList != undefined) {
                            this.lcCodeQCList = this.lcCodeQCList.filter(item => {
                                return item.lcCode.toLowerCase()
                                    .indexOf(query.toLowerCase()) > -1;
                            });
                        }
                    }, 200);
                } else {
                    this.lcCodeQCList = [];
                }
            },
            /**
             * 根据用户工厂编号获取所有的库位
             */
            getSysLocationQualified(LcCode) {
                this.$http
                    .request({
                        url: "/api/location/getLaCodeAllByType",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            lcCode: LcCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.lcCodeQCList = resp.data.list;
                        }else{
                            this.$message({
                                message: resp.message,
                                type: "warning",
                            });
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },

            /**
             * 打开合格库位窗口
             */
            openQualifiedLcCodeDialog(){
                this.getSysLocationQualified();
                this.qualifiedLcCodeDialog = true;
            },
            /**
             * 关闭合格库位窗口
             */
            closeQualifiedLcCodeDialog(){
                this.lcCodeQCList = []
                this.qualifiedLcCode = "";
                this.qualifiedLcCodeDialog = false;
            },
            /**
             * 打开不合格库位窗口
             */
            openUnqualifiedLcCodeDialog(){
                this.getSysLocationQualified();
                this.unqualifiedLcCodeDialog = true;
            },
            /**
             * 关闭不合格库位窗口
             */
            closeUnqualifiedLcCodeDialog(){
                this.lcCodeQCList = [];
                this.qualifiedLcCode = "";
                this.unqualifiedLcCodeDialog = false;
            },

            /**
             * 进行移库操作并质检
             */
            transferInventoryQuality(){
                if (this.qualifiedLcCode == "") {
                    this.$message({
                        message: "请选择需要移入的库位！",
                        type: "warning",
                    });
                    return
                }else{
                    this.$confirm("是否确认该物料进行移库并质检?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.transferInventoryQualityLoading = true;
                        this.$http
                            .request({
                                url: "/api/inventory/transferInventoryQuality",
                                method: "POST",
                                params: {
                                    lcCodeQC: this.qualifiedLcCode,
                                    person: localStorage.getItem("user"),
                                    personNumber: localStorage.getItem("empNumber")
                                },
                                data: this.selectAllPrintList
                            })
                            .then((res) => {
                                if (res.status == 100) {
                                    this.$message({
                                        message: "移库成功，请对该库存重新进行质检！",
                                        type: "success",
                                    });
                                } else {
                                    this.$message({
                                        message: res.message,
                                        type: "error",
                                    });
                                }
                                this.closeTransferLibrary();
                                this.transferInventoryQualityLoading = false;
                            });    
                    })
                    .catch(() => {
                        this.transferInventoryQualityLoading = false;
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
                }
            
            },

            /**
             * 合格或者不合格
             */
            frozenMaterialQualified(qualityStatus){
                if (this.selectAllPrintList.length == 0) {
                    this.$message({
                        message: "请至少选择一条冻结库存记录！",
                        type: "warning",
                    });
                    return
                }
                this.$http
                    .request({
                        url: "/api/order/frozenMaterialQualified",
                        method: "POST",
                        params: {
                            qualityStatus: qualityStatus || null,
                            newLcCode: this.qualifiedLcCode || null,
                            person: localStorage.getItem("user"),
                            personNumber: localStorage.getItem("empNumber")
                        },
                        data: this.selectAllPrintList
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.$message({
                                message: "质检操作成功!",
                                type: "success",
                            });
                            this.closeQualifiedLcCodeDialog();
                            this.closeUnqualifiedLcCodeDialog();
                            this.getMoveLocation();
                        } else {
                            this.$message({
                                message: res.message,
                                type: "error",
                            });
                        }
                    });
            },

            /**
             * 根据工厂和QC类型查询所有的QC库位
             */
            getLcCodeQCList(){
                this.$http
                    .request({
                        url: "/api/location/getLaCodeAllByType",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode"),
                            lcType: "QC",
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.lcCodeQCList = res.data.list;
                        } else {
                            this.$message({
                                message: res.message,
                                type: "error",
                            });
                        }
                    });
            },

            /**
             * 打开移库窗口
             */
            openTransferLibrary(){
                if (this.selectAllPrintList.length == 0) {
                    this.$message({
                        message: "请至少选择一条冻结库存记录！",
                        type: "warning",
                    });
                    return
                }
                //this.getLcCodeQCList();
                this.getSysLocationQualified();
                this.transferLibraryDialog = true;
            },

            closeTransferLibrary(){
                this.qualifiedLcCode = "";
                this.lcCodeQCList = [];
                this.getMoveLocation();
                this.transferLibraryDialog = false;    
            },

            //确认质检结果
            affirmCheckDetail() {
                console.log(this.selectcheckDetailList)
                if (this.selectcheckDetailList.length == 0) {
                    this.$message({
                        message: "请选择质检记录！",
                        type: "warning",
                    });
                    return
                }
                var num = 0;
                this.selectcheckDetailList.forEach((item) => {
                    console.log("item", item.scdStatus)
                    if (item.scdStatus == undefined) {
                        num += 1;
                    }
                })

                if (num != 0) {
                    this.$message({
                        message: "请选择质检结果！",
                        type: "warning",
                    });
                    return
                }
                this.$confirm("是否确认质检结果?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/stockCheckDetail/updateStockCheckDetail",
                                method: "POST",
                                showLoading: true,
                                data: this.selectcheckDetailList,
                                params: {
                                    person: localStorage.getItem("user"),
                                    personNumber: localStorage.getItem("empNumber")
                                }
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "stockCheckDetail：库品重检详情确认结果操作成功";
                                    this.getMoveLocation()
                                    this.checkDetailClose();
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "warning",
                                    });
                                    this.logRemarks = "stockCheckDetail：库品重检详情确认结果操作失败";
                                }
                                this.logContent = JSON.stringify(this.selectAllPrintList);
                                this.systemLog();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败",
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消收货",
                        });
                    });

            },
            selectcheckDetail(val) {
                this.selectcheckDetailList = val
            },
            //禁选
            checkDetailselectable(row, rowIndex) {
                if (row.scdStatus != undefined && row.clickBoolean == undefined) {
                    return false; // 禁用
                } else {
                    return true; // 不禁用
                }
            },

            //重新质检
            quality() {
                if (this.selectAllPrintList.length == 0) {
                    this.$message({
                        message: "请选择库存记录！",
                        type: "warning",
                    });
                    return;
                }
                var orderCode = this.selectAllPrintList[0].orderCode
                var num = 0;
                var wiStatus = 0;
                this.selectAllPrintList.forEach((item) => {
                    if (item.orderCode != orderCode) {
                        num += 1;
                    }
                    if (item.wiStatus != "NORMAL") {
                        wiStatus += 1;
                    }
                })

                if (num != 0) {
                    this.$message({
                        message: "请选择同一个订单的库存记录！",
                        type: "warning",
                    });
                    return;
                }

                if (wiStatus != 0) {
                    this.$message({
                        message: "请选择状态正常的库存记录！",
                        type: "warning",
                    });
                    return;
                }
                this.$confirm("是否开始质检，并冻结当前库存?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/stockCheck/stockCheckQuality",
                                method: "POST",
                                showLoading: true,
                                data: this.selectAllPrintList,
                                params: {
                                    person: localStorage.getItem("user"),
                                    personNumber: localStorage.getItem("empNumber")
                                }
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "stockCheck：库品重检操作成功";
                                    this.getMoveLocation()
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "warning",
                                    });
                                    this.logRemarks = "stockCheck：库品重检操作失败";
                                }
                                this.logContent = JSON.stringify(this.selectAllPrintList);
                                this.systemLog();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败",
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消收货",
                        });
                    });

            },

            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy)
                window.lazy = window.setTimeout(() => {
                    this.getMoveLocation()
                }, 1000)
            },
            getStockCheckData() {
                this.$http
                    .request({
                        url: "/api/stockCheck/getStockCheckData",
                        method: "GET",
                        params: {
                            pageNum: this.checkData.nowPage, // 页号
                            pageSize: this.checkData.pageSize, // 页大小
                            scCode: this.checkSearch.scCode,
                            matCode: this.checkSearch.matCode,
                            scStatus: this.checkSearch.scStatus,
                            fcCode: this.checkSearch.fcCode,
                            person: this.checkSearch.person,
                            orderCode: this.checkSearch.orderCode,
                            beginTime: this.checkSearch.date ? this.checkSearch.date[0] : null,
                            endTime: this.checkSearch.date ? this.checkSearch.date[1] : null,
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.checkData.data = res.data.list;
                            this.checkData.total = res.data.total;
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },
            //获取质检详情
            getScIdCheckDetailData(scId) {
                this.$http
                    .request({
                        url: "/api/stockCheckDetail/getScIdCheckDetailData",
                        method: "GET",
                        params: {
                            scId: scId
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.checkDetailData.data = res.data.list;
                            this.checkDetailData.total = res.data.total;
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },
            /**
             * 获取移库的库位
             */
            getMoveLocation() {
                this.$http
                    .request({
                        url: "/api/order/getMoveLocation",
                        method: "GET",
                        params: {
                            fcCode: this.mainSearch.fcCode || null, //	工厂编号
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.moveLocationList = res.data.list;
                            if(this.moveLocationList != undefined){
                                this.moveLocationList.forEach((item)=>{
                                    this.moveLocations += "," + item.lcCode            
                                })
                            }
                            this.getTableData();
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },
            /**
             * 导出EXCEL文件查询
             */
            getMoveLocationFile(){
                 this.$http
                    .request({
                        url: "/api/order/getMoveLocation",
                        method: "GET",
                        params: {
                            fcCode: this.mainSearch.fcCode || null, //	工厂编号
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.moveLocationList = res.data.list;
                            if(this.moveLocationList != undefined){
                                this.moveLocationList.forEach((item)=>{
                                    this.moveLocations += "," + item.lcCode            
                                })
                            }
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },
            /**
             * 库存
             */
            getTableData() {
                this.$http
                    .request({
                        url: "/api/inventory/getInventoryAgfreezeList",
                        method: "GET",
                        params: {
                            pageNum: this.mainData.nowPage, //	页号
                            pageSize: this.mainData.pageSize, //	页大小
                            fcCode: this.mainSearch.fcCode || null, //	工厂编号
                            whCode: this.mainSearch.whCode || null, //	通道编号
                            lcCode: this.mainSearch.lcCode || null,
                            //lcType: this.mainSearch.lcType || null,
                            matCode: this.mainSearch.matCode || null, //	物料编号
                            matName: this.mainSearch.matName || null, //	物料描述
                            batchNo: this.mainSearch.batchNo || null, //	批次号
                            wiStatus: this.mainSearch.wiStatus || null, //	库存状态
                            boxBarcode: this.mainSearch.boxBarcode || null, //	箱号
                            opCode: this.mainSearch.orderCode || null, //  订单编号
                            matSpecs: this.mainSearch.matSpecs || null, //  规值
                            lcCodeList: this.mainSearch.lcCodeList + this.moveLocations || null, //  规值
                            beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
                            endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.mainData.data = res.data.list;
                            this.mainData.total = res.data.total;
                            this.moveLocations = "";
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },

            //获取库区
            getDictData() {
                this.$http.request({
                    url: "/api/dictData/getDictData",
                    method: "GET",
                    showLoading: true,
                    params: {
                        ddCode: "LATYPE",
                    },
                }).then((resp) => {
                    if (resp.status == 100) {
                        this.dictDataList = resp.data.list || [];
                    }
                }).catch((error) => {});
            },

            pdfPrint() {
                if (this.selectAllPrintList.length == 0) {
                    this.$message({
                        message: "请选择库存记录！",
                        type: "warning",
                    });
                    return;
                }
                this.printShow = true;
                this.printData = this.selectAllPrintList;
            },

            /**
             * 全选
             */
            selectAllPrintLists(val) {
                this.selectAllPrintList = val;
            },

            //禁选
            checkboxSelect(row, rowIndex) {
                if (row.wiStatus == "NORMAL") {
                    return true; // 不禁用
                } else {
                    return false; // 禁用
                }
            },
            // 关闭弹出框
            checkDetailClose() {
                this.dialogShow = false;
                this.checkDetail = [];
                this.checkDetailData.data = [];
            },

            /**
             * 重置
             */
            resetQualityInspectionSearch(){
                this.qualityInspectionSearch = {
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    fcCode: localStorage.getItem("fcCode") || "", //	工厂编号
                    whCode: "", //	通道编号
                    lcCode: "", //	库位编号
                    lcType: "",
                    matCode: "", //	物料编号
                    matName: "", //	物料描述
                    batchNo: "", //	批次号
                    wiStatus: "AGFREEZE", //	库存状态 normal
                    boxBarcode: "", //	箱号
                    orderCode: "", //  订单编号
                    matSpecs: "", //  规值
                    qualityStatus: "",  //质检状态
                    date: [],
                }
            },

            /**
             * 重置
             */
            reset() {
                this.mainSearch = {
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    fcCode: localStorage.getItem("fcCode") || "", //	工厂编号
                    whCode: "", //	通道编号
                    lcCode: "", //	库位编号
                    lcType: "",
                    matCode: "", //	物料编号
                    matName: "", //	物料描述
                    batchNo: "", //	批次号
                    wiStatus: "AGFREEZE", //	库存状态 normal
                    boxBarcode: "", //	箱号
                    orderCode: "", //  订单编号
                    matSpecs: "", //  规值
                    lcCodeList: "DM0001,DM0002,C002", //  冻结地面货位
                    date: [],
                };
                this.getMoveLocation();
            },

            /**
             * 重置
             */
            resetCheck() {
                this.mainSearch = {
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    fcCode: localStorage.getItem("fcCode") || "", //	工厂编号
                    whCode: "", //	通道编号
                    lcCode: "", //	库位编号
                    lcType: "",
                    matCode: "", //	物料编号
                    matName: "", //	物料描述
                    batchNo: "", //	批次号
                    wiStatus: "AGFREEZE", //	库存状态 normal
                    boxBarcode: "", //	箱号
                    orderCode: "", //  订单编号
                    matSpecs: "", //  规值
                    lcCodeList: "DM0001,DM0002,C002", //  冻结地面货位
                    date: [],
                }
            },


            /**
             * 通道列表
             */
            getWarehouse() {
                this.$http
                    .request({
                        url: "/api/checkTask/getWarehouse",
                        method: "GET",
                        params: {
                            fcCode: this.mainSearch.fcCode || null,
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.warehouseList = res.data;
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },

            /**
             * 盘点——查询条件
             */
            insertStockCheckTaskByParam() {
                this.$confirm("是否确认将所有的查询结果进行盘点?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/checkTask/insertStockCheckTaskByParam",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    fcCode: this.mainSearch.fcCode || null, //	工厂编号
                                    whCode: this.mainSearch.whCode || null, //	通道编号
                                    matCode: this.mainSearch.matCode || null, //	物料编号
                                    matName: this.mainSearch.matName || null, //	物料描述
                                    batchNo: this.mainSearch.batchNo || null, //	批次号
                                    wiStatus: this.mainSearch.wiStatus || null, //	库存状态
                                    boxBarcode: this.mainSearch.boxBarcode || null, //	箱号
                                    beginTime: this.mainSearch.date ?
                                        this.mainSearch.date[0] : null,
                                    endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                }
                                this.getMoveLocation();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败:" + error.message,
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },

            /**
             * 盘点——勾选
             */
            insertStockCheckTaskByList() {
                if (this.checkList.length == 0) {
                    this.$message({
                        message: "请勾选库存！",
                        type: "warning",
                    });
                    return;
                }
                this.$confirm("是否确认将已选择的库存进行盘点?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/checkTask/insertStockCheckTaskByList",
                                method: "POST",
                                showLoading: true,
                                data: this.checkList,
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                }
                                this.getMoveLocation();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败:" + error.message,
                                    type: "warning",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },

            //标签打印
            rePrintBarcode() {
                if (this.selectAllPrintList.length == 0) {
                    this.$message({
                        message: "请勾选打印单！",
                        type: "warning",
                    });
                    return;
                }
                //无码时添加打印限制
                if (this.lazyNext) {
                    this.$message.error('请五秒后再打印！')
                    return
                } else {
                    this.selectAllPrintList.forEach((item) => {

                        // let od = this.orderData.data.find(o => o.orderCode == item.orderCode);
                        var produceTime = moment(item.matCreateTime).format("YYYYMMDD");

                        //T/采购订单/箱号/物料号/数量/规值/批次/生产日期/高度
                        // var qrCode = "T/" + item.orderCode + "/" + item.boxBarcode + "/" + item.matCode + "/" +
                        //     item.matQuan + "/" + item.matSpecs + "/" + item.batchNo +
                        //     "/" + produceTime + "/" + item.boxHeight + "/";

                        //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                        var qrCode = item.boxBarcode + "," + item.orderCode + "," + item.whCode + "," +
                            item.matCode + "," + item.matQuan + "," + item.matSpecs +
                            "," + item.batchNo + "," + produceTime + "," + item.boxHeight + ",,,";

                        if (item.matSpecs == undefined) {
                            item.matSpecs = "";
                        }

                        var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                        var barcodeData = {
                            boxBarcode: item.boxBarcode,
                            prodCode: item.matCode,
                            prodName: item.matName,
                            batchNo: item.batchNo,
                            count: item.matQuan,
                            checkPerson: localStorage.getItem("empNumber"),
                            date: produceTime,
                            poCode: item.orderCode,
                            matSpecs: item.matSpecs,
                            whCode: item.whCode,
                            qrCode: qrCode,
                            supply: "",
                            printTime: printTime,
                            isSta: false,
                            printTwo: false,
                            location: item.lcCode
                        }

                        this.$printer.printWMSBarcode(barcodeData);
                    })

                    this.lazyNext = setTimeout(() => {
                        this.lazyNext = null
                    }, 5000)
                }
            },


            //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                this.getMoveLocationFile();
                this.downFile();   
            },
            downFile(){
                var paramsObj = {
                    fcCode: this.mainSearch.fcCode || null, //	工厂编号
                    whCode: this.mainSearch.whCode || null, //	通道编号
                    lcCode: this.mainSearch.lcCode || null,
                    matCode: this.mainSearch.matCode || null, //	物料编号
                    matName: this.mainSearch.matName || null, //	物料描述
                    batchNo: this.mainSearch.batchNo || null, //	批次号
                    wiStatus: this.mainSearch.wiStatus || null, //	库存状态
                    boxBarcode: this.mainSearch.boxBarcode || null, //	箱号
                    opCode: this.mainSearch.orderCode || null, //  订单编号
                    matSpecs: this.mainSearch.matSpecs || null, //  规值
                    lcCodeList: this.mainSearch.lcCodeList + this.moveLocations || null, //  规值
                    beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
                    endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
                    pageNum: 1,
                    pageSize: 999999,
                }

                this.$http.request({
                    url: '/api/inventory/getInventoryAgfreezeList',
                    method: 'GET',
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                    this.moveLocations = "";
                })
            },
            downLoad(list) {
                console.log(list)
                list.forEach(function(c) {
                    if (c.wiStatus == 'NORMAL') {
                        c['wiStatus'] = '正常'
                    } else if (c.wiStatus == 'FREEZE') {
                        c['wiStatus'] = '拣配中'
                    } else if (c.wiStatus == 'AGFREEZE') {
                        c['wiStatus'] = '冻结'
                    }
                })
                import('@/libs/Export2Excel').then(excel => {
                    const tHeader = ['通道编号', '物料编号', '物料描述', '物料数量', '物料批次', '库位', '包装箱号', '订单编号', '规值','物料状态', '入库时间', '备注']
                    const filterVal = ['whCode', 'matCode', 'matName', 'matQuan', 'batchNo', 'lcCode', 'boxBarcode', 'orderCode', 'matSpecs','wiStatus', 'matCreateTime', 'remark']
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '库品冻结质检单'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "wh_inventory：导出库品冻结质检记录"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },



            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "库品质检",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        showLoading: true,
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
        },
        activated(){
            this.getWarehouse();
            this.getMoveLocation();
            this.getDictData();
            /* 获取首页的数据 */
            // this.getStockCheckData();
        },
    };
</script>

<style scoped>
    .div {
        width: 95%;
        height: 100%;
        /* border: 1px solid black; */
        /* margin-top: 107px; */
        margin-left: 30px;
        margin-bottom: 100px;
        text-align: center
    }

    .div table th {
        width: 100px;
        height: 30px;
        border: 1px solid black;
        background: rgb(201, 197, 197);
        color: rgb(14, 13, 13);
    }

    .div table td {
        width: 100px;
        height: 30px;
        /* border: 1px solid black; */
        color: rgb(14, 13, 13);
    }

    .div1 {
        width: 300px;
        height: 40px;
        /* border: 1px solid black; */
        text-align: left;
        color: rgb(14, 13, 13);
        font-weight: bold;
        margin-left: 50px;
    }
</style>